<template>
  <div class="content--sinoreg">
    <header-blue>
      <h4>Relatórios Impressos de Segurança</h4>
    </header-blue>
    <div class="mt-3">
      <div class="row w-100 mx-auto">
        <div class="col-12">
          <div class="col-9 pl-0 d-flex">
            <div class="col-6 pl-0">
              <label class="label">
                Período:
              </label>

              <div class="d-flex align-items-center mt-2">
                <input id="inicio"
                       v-model="start_date"
                       class="form-control form-control-sm w-50"
                       type="date">
                <span class="mx-2">até</span>
                <input v-model="end_date"
                       class="form-control form-control-sm w-50"
                       type="date">
              </div>
            </div>

            <div class="col-3 pt-1">
              <div class="d-flex">
                <label class="label">
                  Status
                </label>
                <b-form-checkbox id="all_status"
                                 v-model="status"
                                 name="all_status"
                                 switch
                                 class="label ml-2" />

                <label class="label">
                  Todos
                </label>
              </div>

              <b-form-checkbox v-for="(item, index) in status_items"
                               :key="index"
                               v-model="checking_status[index]">
                {{ item.label }}
              </b-form-checkbox>
            </div>
          </div>
        </div>

        <div class="row w-100 mx-auto mt-2">
          <div class="col-12 d-flex">
            <div class="col-4 pl-0">
              <div class="d-flex mb-1">
                <label class="label">
                  Impressos
                </label>
                <b-form-checkbox id="all_impressos"
                                 v-model="impressos"
                                 name="all_impressos"
                                 switch
                                 class="label ml-2" />

                <label class="label">
                  Todos
                </label>
              </div>

              <b-form-checkbox v-for="(item, index) in impressos_items"
                               :key="index"
                               v-model="selected_impressos_items[index]">
                {{ item.label }}
              </b-form-checkbox>
            </div>

            <div class="col-6 mx-auto pl-2">
              <label class="label">
                Selos
              </label>
              <b-form-checkbox v-for="(item, index) in selos_items"
                               :key="index"
                               v-model="selected_selos_items[index]">
                {{ item.label }}
              </b-form-checkbox>
            </div>

            <div class="col-1 px-0 d-flex align-items-end justify-content-end">
              <b-button size="sm"
                        class="px-4"
                        variant="outline-primary"
                        @click="filter">
                Filtrar
              </b-button>
            </div>
          </div>
        </div>
      </div>
      <hr class="custom-hr">

      <div class="row w-100 mx-auto mt-4">
        <div class="col-12 d-flex align-items-center justify-content-end">
          <Pagination
            :per-page="perPage"
            :page="page"
            :last-page="lastPage"
            :select-page="true"
            class="mr-2"
            @onSetPage="(ev) => reloadRelatorios(true, ev)"
            @onPreviousPage="reloadRelatorios(true, page - 1)"
            @onNextPage="reloadRelatorios(true, page + 1)" />

          <div class="col-3 mx-5">
            <div class="d-flex align-items-center">
              <span>Mostrar:</span>
              <v-select v-model="perPage"
                        :options="pageOptions"
                        class="w-50 ml-2"
                        @input="reloadRelatorios(true, page)" />
            </div>
          </div>

          <div>
            <b-button
              variant="secondary"
              size="sm"
              @click="createPdf()">
              <svg
                class="button_edit_label_icon icon--sm">
                <use :xlink:href="'#' + file_pdf.id" />
              </svg>
              Gerar PDF
            </b-button>
          </div>
        </div>
      </div>

      <div class="row w-100 mx-auto mt-4">
        <div class="w-100 pl-0">
          <ReportsTable :prop-fields="table.fields"
                        :prop-items="reports"
                        :prop-busy="table.busy"
                        @sendingDataToTheModal="dataToTheModal" />

          <Pagination
            :per-page="perPage"
            :page="page"
            :last-page="lastPage"
            :select-page="true"
            @onSetPage="(ev) => reloadRelatorios(true, ev)"
            @onPreviousPage="reloadRelatorios(true, page - 1)"
            @onNextPage="reloadRelatorios(true, page + 1)" />

          <ModalReportsDetails :prop-modal-content="modal_content" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  /* components */
  import HeaderBlue from "@/components/SofiaRei/Headers/HeaderBlue"
  import Pagination from "@/components/SofiaRei/Pagination"
  import ModalReportsDetails from '@/views/SofiaRei/Relatorios/ImpressosSeguranca/ImpressosSegurancaRelatoriosDetalhes'
  import ReportsTable from '@/views/SofiaRei/Relatorios/ImpressosSeguranca/ImpressosSegurancaRelatoriosTabela'

  /* services */
  import RelatorioImpressosSeguranca from "@/services/Relatorios/RelatorioImpressosSeguranca"

  /* icons */
  import file_pdf from '@/assets/icons/file-pdf.svg?sprite'

  export default {
    name: 'ImpressosSegurancaRelatorios',
    components: {
      HeaderBlue,
      Pagination,
      ModalReportsDetails,
      ReportsTable
    },
    data () {
      return {
        start_date: null,
        end_date: null,
        status: false,
        status_items: [
          { label: 'Cancelado', value: 'CANCELADO' },
          { label: 'Utilizado', value: 'USADO' },
        ],
        checking_status: [],
        get_status: [],
        impressos: null,
        impressos_items: [
          { label: 'Papel de segurança Registro Civil', value: {value: 'papel_de_seguranca_registro_civil', codigosAtos: ['HC', 'AC', 'PV', 'EP', 'AN', 'AO', 'NT', 'UE', 'CT', 'RB']}},
          { label: 'Traslado', value: {value: 'traslado', codigosAtos: ['ES', 'PR', 'AN']}},
          { label: 'Apostilamento', value: {value: 'apostilamento', codigosAtos: ['AP']}},
        ],
        selected_impressos_items: [],
        get_impressos: [],
        selos_items: [
          { label: 'Selo de autenticação', value: {value: 'selo_de_autenticacao', codigosAtos: ['UA', 'LC']}},
          { label: 'Selo de reconhecimento de firma por autenticidade', value: {value: 'selo_de_reconhecimento_de_firma_por_autenticidade', codigosAtos: ['RA']}},
          { label: 'Selo de reconhecimento de firma por semelhança com valor 1', value: {value: 'selo_de_reconhecimento_de_firma_por_semelhanca_com_valor_1', codigosAtos: ['C1']}},
          { label: 'Selo de reconhecimento de firma por semelhança com valor 2', value: {value: 'selo_de_reconhecimento_de_firma_por_semelhanca_com_valor_2', codigosAtos: ['C2']}},
          { label: 'Selo de reconhecimento de firma por semelhança sem valor 1', value: {value: 'selo_de_reconhecimento_de_firma_por_semelhanca_sem_valor_1', codigosAtos: ['RA']}},
          { label: 'Selo de reconhecimento de firma por semelhança sem valor 2', value: {value: 'selo_de_reconhecimento_de_firma_por_semelhanca_sem_valor_2', codigosAtos: ['CE']}}
        ],
        selected_selos_items: [],
        get_selos: [],
        page: 1,
        lastPage: 1,
        perPage: 15,
        pageOptions: [15, 30, 60, 100],
        table: {
          busy: false,
          fields: [
            {
              key: 'key_data_consumo',
              label: 'Data de utilização',
              sortable: false
            },
            {
              key: 'key_impresso_seguranca',
              label: 'Tipo de impresso',
              sortable: false
            },
            {
              key: 'key_nome_solicitante',
              label: 'Nome do solicitante(OS)',
              sortable: false
            },
            {
              key: 'key_nome_usuario',
              label: 'Nome do usuário que utilizou',
              sortable: false
            },
            {
              key: 'key_mais_detalhes',
              label: 'Mais detalhes',
              sortable: false
            }
          ],
        },
        reports: [],
        modal_content: null,
        file_pdf
      }
    },
    watch: {
      status (newValue) {
        if (newValue) return this.fillingValueInArray ('checking_status', this.status_items.length, true)
        this.fillingValueInArray ('checking_status', this.status_items.length, false)
      },
      checking_status: {
        handler (newArray) {
          this.get_status = []

          newArray.forEach((item, index) => {
            if (item === true)  this.get_status.push(this.status_items[index].value)
          })
        },
        deep: true
      },
      impressos (newValue) {
        if (newValue) {
          this.fillingValueInArray ('selected_selos_items', this.selos_items.length, true)
          return this.fillingValueInArray ('selected_impressos_items', this.impressos_items.length, true)
        }
        this.fillingValueInArray ('selected_selos_items', this.selos_items.length, false)
        this.fillingValueInArray ('selected_impressos_items', this.impressos_items.length, false)
      },
      selected_impressos_items: {
        handler (newArray) {
          this.get_impressos = []

          newArray.forEach((item, index) => {
            if (item === true)  this.get_impressos.push(this.impressos_items[index].value)
          })
        },
        deep: true
      },
      selected_selos_items: {
        handler (newArray) {
          this.get_selos = []

          newArray.forEach((item, index) => {
            if (item === true)  this.get_selos.push(this.selos_items[index].value)
          })
        },
        deep: true
      }
    },
    mounted () {
      this.reloadRelatorios()
    },
    methods: {
      async reloadRelatorios (loaderActive = true, page = 1) {
        try {
          loader({active: loaderActive, text: 'Buscando relatórios'})

          const params = {
            page,
            perPage: this.perPage,
            lastPage: this.lastPage,
            start_date: this.start_date,
            end_date: this.end_date,
            status: this.get_status,
            impressos: this.get_impressos,
            selos: this.get_selos
          }

          const {data} = await RelatorioImpressosSeguranca.getItensRelatorio(params)

          if (data && data.data && data.data.length) {
            this.reports = this.formatData(data.data)
            this.page = data.page
            this.lastPage = data.lastPage
            this.perPage = data.perPage
          } else  {
            this.reports = []
            this.page = 1
            this.lastPage = 1
            this.perPage = 15

            return displayMessage('error', 'Nenhum relatório encontrado!')
          }
        } catch (error) {
          const message = getErrors(error)

          displayMessage('error', 'Erro buscar relatórios!', message.message)
        } finally {
          loader({active: false, text: ''})
          this.scrollList()
        }
      },
      scrollList () {
        setTimeout(() => {
          const listagem = document.querySelectorAll('#inicio')

          if (listagem.length) {
            listagem[0].scrollIntoView({ behavior: 'smooth', block: 'start', inline: "start" })
          }
        }, 100)
      },
      async createPdf () {
        try {
          loader({ text: 'Gerando PDF...', active: true })
          const params = {
            page: this.page,
            perPage: this.perPage,
            lastPage: this.lastPage,
            start_date: this.start_date,
            end_date: this.end_date,
            status: this.get_status,
            impressos: this.get_impressos,
            selos: this.get_selos
          }
          const urlPdf = await RelatorioImpressosSeguranca.getPdfImpressosSeguranca(params)
          window.open(urlPdf)

        } catch (error) {
          const message = getErrors(error)
          displayMessage('error', 'Erro ao gerar PDF', message.message)

        } finally {
          loader({ text: '', active: false })
        }
      },
      dataToTheModal ({data}) {
        this.modal_content = data
      },
      fillingValueInArray (property, length, value) {
        this[property]  = Array(length).fill(value)
      },
      async filter () {
        try {
          loader({active: true, text: 'Filtrando relatórios...'})
          this.page = 1
          const params = {
            page: this.page,
            perPage: this.perPage,
            lastPage: this.lastPage,
            start_date: this.start_date,
            end_date: this.end_date,
            status: this.get_status,
            impressos: this.get_impressos,
            selos: this.get_selos
          }

          const {data} = await RelatorioImpressosSeguranca.getItensRelatorio(params)
          if (data && data.data && data.data.length) {
            this.reports = this.formatData(data.data)
            this.page = data.page
            this.lastPage = data.lastPage
            this.perPage = data.perPage
          } else  {
            this.reports = []
            this.page = 1
            this.lastPage = 1
            this.perPage = 15

            return displayMessage('error', 'Nenhum relatório encontrado!')
          }

        } catch (error) {
          const message = getErrors(error)
          displayMessage('error', 'Erro ao filtrar relatórios!', message.message)

        } finally {
          loader({ text: '', active: false })
        }
      },
      formatData (data) {
        const newData = data.map((item) => {
          return {
            ...item,
            nome_solicitante: item?.ordemServico ? item?.ordemServico?.nome_solicitante : '---',
            impresso_seguranca: this.formatarTextoParaLabel(item?.papelSegurancaLote?.tipo_papel),
            matricula: item?.registro ? item.registro.matricula : '---',
            num_selo: '---',
            nome_usuario: item.nome_usuario || '---',
          }
        })
        return newData
      },
      formatarTextoParaLabel (texto) {
        // Substitui todos os underscores por espaços e divide o texto em palavras
        const palavras = texto.replace(/_/g, ' ').split(' ')
  
        // Capitaliza a primeira letra de cada palavra e junta-as de volta em uma string
        const labelFormatada = palavras.map(palavra => 
          palavra.charAt(0).toUpperCase() + palavra.slice(1)
        ).join(' ')

        return labelFormatada
      }
    }
  }
</script>

<style lang="scss">
.custom-hr {
  border: none;
  height: 2px;
  background-color: grey;
  opacity: 0.5;
}
</style>
